var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5839 12.0081L12.5927 11.9992L12.5839 11.9904L8.68386 8.09038C8.5031 7.90962 8.41252 7.67958 8.41252 7.39922C8.41252 7.11886 8.5031 6.88882 8.68386 6.70806C8.86462 6.5273 9.09467 6.43672 9.37502 6.43672C9.65538 6.43672 9.88543 6.5273 10.0662 6.70806L14.6662 11.3081C14.7651 11.4069 14.8348 11.5137 14.8758 11.6284C14.9169 11.7436 14.9375 11.8672 14.9375 11.9992C14.9375 12.1312 14.9169 12.2548 14.8758 12.37C14.8348 12.4847 14.7651 12.5915 14.6662 12.6904L10.0662 17.2904C9.88543 17.4711 9.65538 17.5617 9.37502 17.5617C9.09467 17.5617 8.86462 17.4711 8.68386 17.2904C8.5031 17.1096 8.41252 16.8796 8.41252 16.5992C8.41252 16.3189 8.5031 16.0888 8.68386 15.9081L12.5839 12.0081Z",
    fill: "#666666",
    stroke: "#D0D0D0",
    strokeWidth: 0.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.df75848486827e71340e09ff5d1d0b46.svg";
export { ForwardRef as ReactComponent };